export const AJOUTE_OFFRE = "AJOUTE_OFFRE";
export const SUPRIMER_OFFRE = "SUPRIMER_OFFRE";